import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SystemMessageService } from 'app/core/system-message/system-message-service';
import { ReportFilterVm } from 'app/shared/generated/Report/Models/ReportFilterVm'
import { saveAs } from 'file-saver'


@Component({
    selector: 'pcg-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent implements OnInit {

  formGroup = ReportFilterVm.Form;
  model = ReportFilterVm.GetModel(this.formGroup);

  constructor(private httpClient: HttpClient, private ms: SystemMessageService,) { }

  ngOnInit(): void {
    this.httpClient.get('api/Report/Report/GetReportFiltersVm')
      .subscribe((model: ReportFilterVm) => {
        this.formGroup.patchValue(model);
      })
  }

  public generateReport() {
    if(!this.formGroup.valid)
      return;
      
    const httpOptions = {
      responseType: 'blob' as 'json',
      params: new HttpParams().set("monthYearString", this.formGroup.get('monthYearString').value)
    };

    let month: string = (this.formGroup.get('monthYearString').value as string).split(' ')[1];
    let year: string = (this.formGroup.get('monthYearString').value as string).split(' ')[0];
    let date = new Date();
    date.setMonth((+month) - 1);
    date.setFullYear(+year);
    let dateString = date.toLocaleDateString("default", { month: "long", year: "numeric" });

    this.httpClient.post('api/Report/Report/GenerateReport', this.formGroup.getRawValue(), {observe: 'response', responseType: 'blob' as 'json'})
    .subscribe((data: any) => {
      const blob = new Blob([data.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const file = new File([blob], `${dateString} Rates`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      this.ms.setSystemMessage("Excel generated successfully.");
      saveAs(file);
    });
  }

}
